<span class="e-resize-handle__grip" aria-hidden="true"></span>
<!-- Enkel met de muis: het toetsenbord zet terug met Home (een knop in een separator is voor schermlezers onzichtbaar). -->
@if (available() && size() != null && !dragging()) {
  <button
    type="button"
    class="e-resize-handle__button e-resize-handle__reset"
    tabindex="-1"
    data-test-id="e-resize-handle-reset"
    [attr.title]="resetLabel()"
    [attr.aria-label]="resetLabel()"
    (pointerdown)="onButtonPointerDown($event)"
    (click)="reset()"
  ><i class="fas fa-arrow-right-to-line" aria-hidden="true"></i></button>
}
<!-- De tegenhanger onder de greep: het paneel op maat van zijn inhoud (het toetsenbord heeft End). -->
@if (available() && contentShortfall() != null && !atMaximum() && !dragging()) {
  <button
    type="button"
    class="e-resize-handle__button e-resize-handle__fit"
    tabindex="-1"
    data-test-id="e-resize-handle-fit"
    [attr.title]="fitLabel()"
    [attr.aria-label]="fitLabel()"
    (pointerdown)="onButtonPointerDown($event)"
    (click)="fitToContent()"
  ><i class="fas fa-arrow-left-to-line" aria-hidden="true"></i></button>
}
